require('./pages/promotions/steps/infos')

import PromotionInfos from './pages/promotions/steps/infos';
customElements.define('ecommerce-promotion-infos',PromotionInfos,{extends: 'select'});